import { Component, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { CustomizerColorsAutoUpdateComponent, CustomizerComponentHeaderComponent } from '@app/customizer/components';
import { PreciousMetalInfoComponent } from '@app/customizer/components/precious-metal-info/precious-metal-info.component';
import { ConfigurationService } from '@services/configuration.service';
import { ComponentVariantFromApiModel } from '@models/api-models/component-variant-fromapi';
import { ComponentVariantModel } from '@models/component-variant';
import { ComponentVariantChangeModel } from '@models/component-variant-change';
import { VariantColorModel } from '@models/variant-color';
import { EventsService } from '@services/events.service';
import { DataApiService } from '../../../../_services/data-api.service';
import { AngleConstants } from '../../../../shared/angle-constants';
import { BaseCustomizerComponent } from './../../../../shared/base-customizer-component';

@Component({
    selector: 'frame-color-menu',
    template: `
    <customizer-component-header [menu]="menu" (updateCollapsedOnComponent)="updateCollapsed($event)">
      @if (selectableVariants.length) {
        <customizer-colors-auto-update
          [selected]="getSelectedVariant.VariantColor"
          [selectedColorGroup]="currentColorGroup"
          [variants]="selectableVariants"
          [editMode]="state === customizerStateEnum.EDITORDER"
          [matchableColors]="matchableColors"
          [useColorGroup]="menu.contentGrouping"
          (colorMatchChange)="matchColors($event)"
          (selectedColorGroupChange)="onSelectGroup($event)"
          (selectedColorChange)="onSelect($event)"
          [(scrollPosition)]="menu.menuDetails.scrollPosition"
          [variantOrModelIsNew]="variantOrModelIsNew"
          [matchColor]="menu.matchColor"
          >
        </customizer-colors-auto-update>
      }
    </customizer-component-header>
    <precious-metal-info></precious-metal-info>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CustomizerComponentHeaderComponent, CustomizerColorsAutoUpdateComponent, PreciousMetalInfoComponent]
})
export class FrameColorComponent extends BaseCustomizerComponent {

	selectableVariants: Array<ComponentVariantFromApiModel> = [];

	constructor(
		public override events: EventsService,
		public apiService: DataApiService,
		public override configurationService: ConfigurationService
	) {
		super(events, apiService, configurationService);
	}

	async initData() {
		this.events.showLoader(true);

		this.selectableVariants = await this.fetchData();

		this.events.showLoader(false);
	}

	onChanges(changes: SimpleChanges): void {
		this.setImageSliderByName(AngleConstants.Perspective);
	}

	async fetchData(): Promise<Array<ComponentVariantFromApiModel>> {

		const variants = this.getCurrentVariants;
		let variantsFromApi = new Array<ComponentVariantFromApiModel>();

		for (const variant of variants) {
			const apidata = await this.configurationService.getVariants(this.configuration?.ModelConfigurationUuid, this.modelGroup, undefined, variant.Uuid, variant.VariantSize?.Uuid);
			variant.VariantColorViewed = true;
			variantsFromApi = apidata ? [...variantsFromApi, ...apidata] : [...variantsFromApi];
		}

		await this.RunDisablingSystem(variantsFromApi);

		return variantsFromApi;
	}

	onSelect(color: VariantColorModel) {
		if (!color) return;
		
		this.events.showLoader(true);

		const currentVariants = this.getCurrentVariants;
		if (!currentVariants || currentVariants.length === 0) {
			return;
		}

		currentVariants.forEach(variant => {
			if (!variant) return;
			
			const selectableVariant = this.selectableVariants?.find(x => x?.Code === variant.Code);
			if (!selectableVariant || !selectableVariant.VariantSizes || selectableVariant.VariantSizes.length === 0) return;
			
			const selectedColor = selectableVariant.VariantSizes[0]?.VariantColors?.find(x => x?.ColorUuid === color.ColorUuid);
			if (!selectedColor) return;

			const newVariant = Object.assign(new ComponentVariantModel(variant.Discontinued, variant.New), variant);
			const oldVariant = Object.assign(new ComponentVariantModel(variant.Discontinued, variant.New), variant);
			newVariant.VariantColor = selectedColor;
			this.updateVariant(new ComponentVariantChangeModel(oldVariant, newVariant, null));
		});
	}

}
